import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { filter, take } from 'rxjs';
import {
  ColDef,
  GridOptions,
  GridReadyEvent,
  SideBarDef,
} from 'ag-grid-community';
import { ShipmentService } from 'src/app/services/modules/shipments/shipment.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoDialogComponent } from 'src/app/components/info-dialog/info-dialog.component';
import { SavedSearchComponent } from 'src/app/components/saved-search/saved-search.component';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-shipment-listing',
  encapsulation: ViewEncapsulation.Emulated,
  templateUrl: './shipment-listing.component.html',
  styleUrls: ['./shipment-listing.component.scss'],
  providers: [ConfirmDialogComponent],
})
export class ShipmentListingComponent implements OnInit {
  public selectedStatus: string[] = [];
  public statuses!: any[];

  public columnDefs: ColDef[] = [];

  public gridApi: any;
  public showSelect: boolean = true;

  public viewFilterType: string = 'listing';
  public module: string = 'shipment';

  public paginationPageSize = 20;
  public paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];

  public skipEventHandler: boolean = false;
  public fromDashboard: boolean = false;

  @ViewChild('savedSearch') savedSearch!: SavedSearchComponent;

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    // flex: 1,
    width: 130,
    filter: true,
    // sortable: true,
    floatingFilter: true,
    // lockPinned: true,
    resizable: true,
  };
  public sideBar: SideBarDef | string | string[] | boolean | null = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
    defaultToolPanel: 'filters',
    hiddenByDefault: true,
  };

  public cacheBlockSize = 10;
  public maxBlocksInCache = 10;
  public rowData!: any[];
  public customerDetails: any;
  public customerId: any = null;

  constructor(
    private shipmentService: ShipmentService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private _modalService: NgbModal,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.authService.user$
      .pipe(
        filter((user) => !!user),
        take(1),
      )
      .subscribe((user: any) => {
        this.customerId = user.customer_id;
      });

    this.selectAllForDropdownItems(this.getStatus());
    // this.getCustomerDetails();
  }

  private checkFromDashboard() {
    this.route.queryParams.subscribe((params) => {
      if (params['filter']) {
        this.fromDashboard = true;

        this.applyStatusFilter(params['filter'].toLowerCase());
        this.clearUrlParams();
        if (this.savedSearch) this.savedSearch.clearFilter();
        this.skipEventHandler = true;
      } else {
        this.selectedStatus = [];
      }
    });
  }

  clearUrlParams() {
    console.log('###clearUrlParams');
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
  }

  // Used from re-direct from dashboard
  applyStatusFilter(filterValue: string) {
    console.log('###applyStatusFilter - filterValue', filterValue);
    this.showSelect = false;
    setTimeout(() => {
      console.log('###this.statuses', this.statuses);

      if (this.statuses) {
        const status = this.statuses.find(
          (s) => s.value.toLowerCase() === filterValue,
        );

        console.log('###applyStatusFilter - status', status);

        if (status && status.name) {
          this.selectedStatus = [status.value];
          console.log(
            '###applyStatusFilter - this.selectedStatus',
            this.selectedStatus,
          );
          //this.statusLabelName(status);
        } else {
          this.selectedStatus = []; // Fallback if no status is found
        }
        this.onSelectionChange();
        this.showSelect = true;
        //this.cdr.detectChanges();
      }
    });
  }

  fetchDataRow(queryString: string = '') {
    return this.shipmentService.getCustomerListing(queryString).pipe(take(1));
  }

  onGridReady(params: GridReadyEvent<any>) {
    console.log('###onGridReady');
    this.gridApi = params.api;

    let queryString = '';
    let pickedStatus: string[] = [];
    pickedStatus = ['All'];

    if (this.fromDashboard) {
      pickedStatus = this.selectedStatus;
      this.fromDashboard = false;
    }

    for (let i = 0; i < pickedStatus.length; i++) {
      queryString += `status_array[]=${encodeURIComponent(pickedStatus[i])}&`;
    }

    queryString = queryString.slice(0, -1);

    this.fetchDataRow(queryString).subscribe((res: any) => {
      console.log(res);
      let idSequence = 0;
      res.data.data.forEach((item: any) => {
        item.id = idSequence++;
      });
      this.rowData = res.data.data;
      if (this.savedSearch) this.savedSearch.refresh(this.gridApi);

      console.log('####res.data.columns', res.data.columns);
      this.columnDefs = this.shipmentService.transformListingColumn(
        res.data.columns,
      );
    });
    this.setSideBarVisible(true);
  }

  setSideBarVisible(value: boolean) {
    this.gridApi.setSideBarVisible(value);
  }

  statusLabelName(v: any) {
    if (v.name) return v.name;
    if (v.value) return v.value;
    return 'All Statuses';
  }

  getStatus() {
    let status: any = this.shipmentService
      .fetchStatus(this.viewFilterType)
      .pipe(take(1))
      .subscribe((res: any) => {
        this.statuses = res.data;
        console.log('INSIDE ###getStatus - this.statuses', this.statuses);
        this.checkFromDashboard();
      });
    console.log('###getStatus - this.statuses', this.statuses);
    return this.statuses;
  }

  // Setter
  set setSelectedStatus(v: any) {
    console.log(v);
    this.selectedStatus = v;
  }

  // items is all the statues
  selectAllForDropdownItems(items: any[]) {
    console.log('###selectAllForDropdownItems');
    let allSelect = (items: any[]) => {
      if (items) {
        items.forEach((element: { [x: string]: string }) => {
          element['selectedAllGroup'] = 'All Statuses';
        });
      }
    };

    allSelect(items);
  }

  onColumnVisible(event: any) {
    if (this.savedSearch) this.savedSearch.saveColumnState();
  }

  clearFilter() {
    if (this.savedSearch) this.savedSearch.clearFilter();
  }

  clearFiltersExternally() {
    this.selectedStatus = [];
  }

  eventHandlingListener(event: any) {
    if (this.savedSearch) {
      this.savedSearch.handleGridEvent(event);
    }
  }

  onSelectionChange() {
    console.log('onSelectionChange');

    let pickedStatus: string[] = [];
    let isSelectedAll: boolean = this.selectedStatus.includes('All Statuses');

    if (this.statuses.length === this.selectedStatus.length || isSelectedAll) {
      this.setSelectedStatus = [{ selectedAllGroup: 'All Statuses' }];
      this.statuses.forEach((e, index) => {
        pickedStatus[index] = e.value;
      });
    } else {
      if (this.selectedStatus.length == 0) {
        pickedStatus = ['All'];
      } else {
        pickedStatus = this.selectedStatus;
      }
    }

    let queryString = '';

    for (let i = 0; i < pickedStatus.length; i++) {
      queryString += `status_array[]=${encodeURIComponent(pickedStatus[i])}&`;
    }
    queryString = queryString.slice(0, -1);

    this.fetchDataRow(queryString).subscribe((res: any) => {
      let idSequence = 0;
      res.data.data.forEach((item: any) => {
        item.id = idSequence++;
      });
      this.rowData = res.data.data;
      if (this.savedSearch) this.savedSearch.fetchViewFilterList(true);
      this.columnDefs = this.shipmentService.transformListingColumn(
        res.data.columns,
      );
    });
  }

  compareAccounts = (item: any, selected: any) => {
    if (selected.selectedAllGroup && item.selectedAllGroup) {
      return item.selectedAllGroup === selected.selectedAllGroup;
    }
    return false;
  };

  getCustomerDetails() {
    this.authService.user$
      .pipe(
        filter((user) => !!user),
        take(1),
      )
      .subscribe((user: any) => {
        this.customerDetails = user;
      });
  }
}
